<template>
    <span class="header-control-item" :class="[iconTransitionClass]" v-on="$listeners">
        <i class="header-control-item-icon" :data-count="dataCount">
            <slot name="icon"/>
        </i>
        <span class="header-control-item-text">{{ title }}</span>
    </span>
</template>

<script>
    export default {
        name: "ControlItem",
        props: {
            title: String,
            count: Number,
        },
        data() {
            return {
                iconTransitionClass: null,
            }
        },
        computed: {
            dataCount() {
                return !this.count ? "" : this.count;
            }
        },
        watch: {
            count() {
                if (!this.count) {
                    return;
                }

                this.iconTransitionClass = 'control-item-transition-icon';

                setTimeout(() => {
                    this.iconTransitionClass = null
                }, 500)
            }
        }
    }
</script>
